import './assets/css'

import React, { lazy } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import PrivateLayout from './components/private-layout'
import { routesDef } from './config/routes'
import { CenterScreen } from '@ztechapps/webui.util'
import { LoadingLayout, PageLayoutNotFound } from '@ztechapps/webui.page'
import { ApolloProvider } from '@apollo/client'
import { AppContextProvider } from './hooks/useAppContext'
import { setupApolloClient } from './config/graphql'

// Dashboard
const Dashboard = lazy(() => import('./view/dashboard'))

// Messages
const InboxPage = lazy(() => import('./view/messages/inbox'))
const OutboxPage = lazy(() => import('./view/messages/outbox'))

// Settings
const SettingsPage = lazy(() => import('./view/settings'))
const SimsSettingsPage = lazy(() => import('./view/settings/sims'))
const WebhooksSettingsPage = lazy(() => import('./view/settings/webhooks'))
const OrganizationSettingsPage = lazy(() => import('./view/settings/organization'))

// Account
const LoginPage = lazy(() => import('./view/account/login'))
const LoginSuccessPage = lazy(() => import('./view/account/login-success'))
const LoginFailedPage = lazy(() => import('./view/account/login-failed'))
const LoadingPage = lazy(() => import('./view/account/loading'))
const ChangePasswordPage = lazy(() => import('./view/account/change-password'))
const JoinPage = lazy(() => import('./view/account/join'))

export const App = () => {
  const [apolloClient, setApolloClient] = React.useState<any>(null)

  React.useEffect(() => {
    const init = async () => {
      const client = setupApolloClient()
      setApolloClient(client)
    }
    init()
  }, [])

  if (!apolloClient) return <CenterScreen>Loading...</CenterScreen>

  return (
    <BrowserRouter>
      <ApolloProvider client={apolloClient}>
        <AppContextProvider>
          <LoadingLayout>
            <Routes>
              {/* Public routes */}
              <Route index element={<LoadingPage />} />
              <Route path={routesDef.LoginPage.path} element={<LoginPage />} />
              <Route path={routesDef.JoinPage.path} element={<JoinPage />} />
              <Route path={routesDef.ChangePasswordPage.path} element={<ChangePasswordPage />} />
              <Route path={routesDef.AuthSuccessPage.path} element={<LoginSuccessPage />} />
              <Route path={routesDef.AuthFailedPage.path} element={<LoginFailedPage />} />

              {/* Private routes */}
              <Route path="/app" element={<PrivateLayout />}>
                {/* Dashboard */}
                <Route path={routesDef.DashboardPage.path} element={<Dashboard />} />

                {/* Messages */}
                <Route path={routesDef.InboxPage.path} element={<InboxPage />} />
                <Route path={routesDef.OutboxPage.path} element={<OutboxPage />} />

                {/* Settings */}
                <Route path={routesDef.SettingsPage.path} element={<SettingsPage />} />
                <Route path={routesDef.SettingsSimsPage.path} element={<SimsSettingsPage />} />
                <Route path={routesDef.SettingsWebhooksPage.path} element={<WebhooksSettingsPage />} />
                <Route path={routesDef.SettingsOrganizationPage.path} element={<OrganizationSettingsPage />} />
              </Route>

              {/* 404 */}
              <Route path="*" element={<PageLayoutNotFound />} />
            </Routes>
          </LoadingLayout>
        </AppContextProvider>
      </ApolloProvider>
    </BrowserRouter>
  )
}
